import { Component, Input } from '@angular/core';
import { faCircleExclamation, faExclamation, faWarning } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'aviso',
  templateUrl: './aviso.component.html',
  styleUrls: ['./aviso.component.css']
})
export class AvisoComponent {
  @Input() textoAviso!: any;
  @Input() valor!: any;
  //Icones
  faWarning = faWarning;
  faCircleExclamation = faCircleExclamation;
  faExclamation = faExclamation;
}
